package com.partejar.app.core.ui.theme

import androidx.compose.runtime.Immutable
import androidx.compose.runtime.staticCompositionLocalOf
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp

@Immutable
data class PartejarDimensions(
    val minimumTouchTarget: Dp = 44.dp,
    val iconSmall: Dp = 16.dp,
    val iconMedium: Dp = 20.dp,
    val iconDefault: Dp = 24.dp,
    val iconLarge: Dp = 32.dp,
    val strokeThin: Dp = 1.dp,
    val strokeStrong: Dp = 2.dp,
    val controlHeight: Dp = 52.dp,
    val topBarHeight: Dp = 64.dp,
    val floatingDockMinHeight: Dp = 64.dp,
    val floatingDockElevation: Dp = 8.dp
)

internal val DefaultPartejarDimensions = PartejarDimensions()

internal val LocalPartejarDimensions = staticCompositionLocalOf {
    DefaultPartejarDimensions
}
